import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

/**
 * Preserve Creator Social snowflake IDs that exceed Number.MAX_SAFE_INTEGER.
 * Without this, Creator post/journey cards round IDs before route construction.
 */
function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:postId|socialPostId|authorMemberId|memberId|linkedJourneyPublicationId|linkedLocationId|quotedSocialPostId|locationId|publicationId|journeyId|creatorMemberId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

export const creatorApi = {
  getProfile: (memberId) => travelClient.get(travelEndpoints.creator(memberId), snowflakeJson),
  listPosts: (memberId, params) => travelClient.get(travelEndpoints.creatorPosts(memberId), { params, ...snowflakeJson }),
  listJourneys: (memberId, params) => travelClient.get(travelEndpoints.creatorJourneys(memberId), { params, ...snowflakeJson }),
};
